import { REGION_CANDIDATES } from '../../define/consts/solution';
import { isRequiredText } from '../utils';
export const requiredWithRegionOther = (value, record) => {
    const index = REGION_CANDIDATES.length - 1;
    const regions = record.regions || [];
    const otherCheck = !!regions[index];
    if (otherCheck) {
        return isRequiredText('地方エリアを選択した場合は詳細を入力してください')(value);
    }
    return '';
};
export default requiredWithRegionOther;
